module.exports = __webpack_public_path__ + "img/EXV_SD_Nav-Icon_Weinsuche.aba73970.svg";